module.exports = __webpack_public_path__ + "static/easycourse_logo-9d3c06ee72bad3bde82a377d92ea7f47.png";